var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
export function filtersToQueryValues(filters) {
    const filterKeys = Object.keys(filters);
    const filterValues = filterKeys.map((key) => `${filters[key]}`);
    return { q: filterKeys, qv: filterValues };
}
/**
 * Deletes item from history
 */
export function deleteContent(content, deleteParams = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const defaults = { purge: false, recursive: false, stop_job: true };
        const params = Object.assign({}, defaults, deleteParams);
        const { data, error } = yield GalaxyApi().DELETE("/api/histories/{history_id}/contents/{type}s/{id}", {
            params: {
                path: { history_id: content.history_id, type: content.history_content_type, id: content.id },
                query: params,
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
/**
 * Update specific fields on datasets or collections.
 */
export function updateContentFields(content, newFields = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().PUT("/api/histories/{history_id}/contents/{type}s/{id}", {
            params: {
                path: { history_id: content.history_id, type: content.history_content_type, id: content.id },
            },
            body: newFields,
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
/**
 * Performs an operation on a specific set of items or all the items
 * matching the filters.
 * If a specific set of items is provided, the filters are ignored, otherwise
 * the filters will determine which items are processed.
 */
export function bulkUpdate(history, operation, filters, items = [], params = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().PUT("/api/histories/{history_id}/contents/bulk", {
            params: {
                path: { history_id: history.id },
                query: filtersToQueryValues(filters),
            },
            body: {
                operation,
                items,
                params,
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function createDatasetCollection(history, inputs = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const defaults = {
            collection_type: "list",
            copy_elements: true,
            name: "list",
            element_identifiers: [],
            hide_source_items: true,
        };
        const payload = Object.assign({}, defaults, inputs);
        const { data, error } = yield GalaxyApi().POST("/api/histories/{history_id}/contents", {
            params: { path: { history_id: history.id } },
            body: Object.assign(Object.assign({}, payload), { instance_type: "history", type: "dataset_collection" }),
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
